import React from "react";
import { cls } from "@wss/cls";
import { User } from "~/common/Store/models/User";
import { CustomerExclusivity } from "~/common/Store/models/ProductListing";

interface Props {
  user: User;
  customerExclusivity: CustomerExclusivity;
  extraClassNames?: string;
}

const PlatinumPlusExclusive = ({
  user,
  customerExclusivity,
  extraClassNames = "text-gray-600",
}: Props) => {
  if (!customerExclusivity) return null;

  const exclusiveText = user.hasWebPlus ? "Plus" : "Platinum";
  const displayExclusiveTag =
    customerExclusivity.allowPlatinumToPurchase ||
    customerExclusivity.allowWebstaurantPlusToPurchase;

  const displayExclusiveText =
    (customerExclusivity.allowPlatinumToPurchase && user?.platinum?.enabled) ||
    (customerExclusivity.allowWebstaurantPlusToPurchase && user?.hasWebPlus);

  return (
    <>
      {displayExclusiveTag && (
        <div
          className={cls(
            "exclusive-tag",
            extraClassNames,
            `exclusive-tag--${exclusiveText.toLowerCase()}`,
          )}
        >
          {displayExclusiveText
            ? `${exclusiveText} Exclusive`
            : "Temporarily Unavailable"}
        </div>
      )}
    </>
  );
};
export default PlatinumPlusExclusive;
